import React, { useEffect, useState } from "react";
import { Link as RouterLink, useParams } from "react-router-dom";
import axios from "axios";
import { Alert, Box, Button, CircularProgress, Container, Typography } from "@mui/material";
import { NationsLeagueEvent } from "../types";
import { NationsLeagueFaqAccordions } from "../components/NationsLeagueFaqDialog";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3001";

const NationsLeagueFaq: React.FC = () => {
  const { nationsLeagueId } = useParams<{ nationsLeagueId: string }>();
  const [event, setEvent] = useState<NationsLeagueEvent | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    axios
      .get(`${API_URL}/api/nations-league/${nationsLeagueId}`)
      .then((res) => setEvent(res.data))
      .catch(() => setError("Failed to load this edition"))
      .finally(() => setLoading(false));
  }, [nationsLeagueId]);

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 6 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
      {error || !event ? (
        <Alert severity="error">{error || "Edition not found"}</Alert>
      ) : (
        <>
          <Typography variant="h4" sx={{ fontWeight: "bold", mb: 2 }}>
            🏆 {event.name}
          </Typography>

          {event.description && (
            <Typography sx={{ whiteSpace: "pre-wrap", mb: 4 }}>{event.description}</Typography>
          )}

          <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>
            FAQ
          </Typography>
          {(event.faq || []).length === 0 ? (
            <Alert severity="info">No questions have been added yet.</Alert>
          ) : (
            <NationsLeagueFaqAccordions faq={event.faq || []} />
          )}

          <Button component={RouterLink} to={`/cupOfNations/${event.id}`} sx={{ mt: 3 }}>
            View standings
          </Button>
        </>
      )}
    </Container>
  );
};

export default NationsLeagueFaq;
